import { render, staticRenderFns } from "./AdminCustomerDetail.vue?vue&type=template&id=e2e69008&scoped=true"
import script from "./AdminCustomerDetail.vue?vue&type=script&lang=js"
export * from "./AdminCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminCustomerDetail.vue?vue&type=style&index=0&id=e2e69008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e69008",
  null
  
)

export default component.exports